import cookie from 'cookie'
import contentDisposition from 'content-disposition'
import moment from 'moment'
import store from './store'

/**
 * Возвращает строку, первая буква которой преобразована к заглавной.
 *
 * @param {string} string
 * @returns {string}
 */
export function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Проверяет пустые ли указанные данные.
 *
 * @param data
 * @returns {boolean}
 */
export function empty (data) {
  return !!(isNaN(data) || data === null || typeof data === 'undefined')
}

/**
 * Округляет число.
 *
 * @param {number} value
 * @param {number} digits
 * @returns {number}
 */
export function round (value, digits = 2) {
  const pow = Math.pow(10, digits)
  return Math.round(pow * value) / pow
}

/**
 * Устанавливает куку, в которой указана текущая страница для редиректа посте авторизации.
 */
export function setAuthRedirectUrlCookie () {
  document.cookie = cookie.serialize('_cauth_redirect_url', window.location, {
    domain: '.demis.ru',
    path: '/',
    maxAge: 600
  })
}

/**
 * Форматирует размер файла в целовекопонятной форме.
 *
 * @param {Number} size
 * @param {Number} fractionDigits Количество знаков после запятой.
 * @returns {string}
 */
export function formatSize (size, fractionDigits = 0) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(fractionDigits) + ' ТБ'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(fractionDigits) + ' ГБ'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(fractionDigits) + ' МБ'
  } else if (size > 1024) {
    return (size / 1024).toFixed(fractionDigits) + ' КБ'
  }
  return size.toString() + ' Б'
}

/**
 * Сохраняет загруженный файл в браузере.
 *
 * @param response
 */
export function saveFile (response) {
  const fileURL = window.URL.createObjectURL(new Blob([response.data]))
  const fileLink = document.createElement('a')

  fileLink.href = fileURL
  fileLink.setAttribute(
    'download',
    contentDisposition.parse(response.headers['content-disposition']).parameters.filename
  )
  document.body.appendChild(fileLink)

  fileLink.click()
}

/**
 * @param from
 * @param to
 * @returns {{}}
 */
export function getMonthsFormated (from, to) {
  const dates = {}

  for (let m = moment(from); m.isSameOrBefore(moment(to), 'months'); m.add(1, 'months')) {
    dates[m.startOf('month').format('YYYY-MM-DD')] = capitalizeFirstLetter(m.format('MMMM YYYY'))
  }

  return dates
}

export function getYearsFormated (from, to) {
  const dates = {}

  for (let m = moment(from); m.isSameOrBefore(moment(to), 'years'); m.add(1, 'years')) {
    const year = m.format('YYYY')

    dates[year] = year
  }

  return dates
}

/**
 * Если выбранное ядро/проект отсутствует среди ядер по выбранному региону,
 * делаем выбранным первое ядро из списка ядер по выбранному региону.
 */
export function handleClientProjectsSelectedRegionChange () {
  if (!Object.prototype.hasOwnProperty.call(
    store.getters['seo/client/projects/getCoresListOfSelectedRegion'],
    store.state.seo.client.projects.selectedProjectId
  )) {
    store.dispatch(
      'seo/client/projects/changeSelectedProjectId',
      store.getters['seo/client/projects/getProjectsOfSelectedRegion'][0].id_parent
    )
  }
}

export function conclusion1CToHtml (conclusion) {
  const colorRegex = /<color(.*?)>/g
  const liRegex = /<li(.*?)>/g

  return conclusion.replace(colorRegex, '<color>').replace(liRegex, '<li>')
}

/**
 * Добавляет к ссылке параметр client_id, если необходимо.
 *
 * @param {String} link
 * @returns {string|*}
 *
 * @deprecated
 */
export function joinClientId (link) {
  return store.state.seo.projects.selectedClientId
    ? `${link}?client_id=${store.state.seo.projects.selectedClientId}` : link
}

/**
 * Добавляет к ссылке query-параметр _impersonate с логином выбранного в impersonation
 * клиента, если режим impersonation активен. Возвращает итоговую ссылку.
 *
 * @param {String} url
 * @returns {String}
 */
export function joinImpersonate (url) {
  const login = store.state.impersonation && store.state.impersonation.selectedClientLogin
  if (!login) {
    return url
  }
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}_impersonate=${encodeURIComponent(login)}`
}

/**
 * Декодирует HTML, заменяет последовательности символов вида &lt; на реальные символы.
 *
 * @param html
 * @returns {string}
 */
export function decodeHtml (html) {
  const txt = document.createElement('textarea')
  txt.innerHTML = html
  const decodedHtml = txt.value
  txt.remove()

  return decodedHtml
}

/**
 * Возвращает дату и время последнего доступного в 1С ежемесячного отчета.
 *
 * В 1С отчеты генерируются 24 числа каждого месяца в 06:00.
 *
 * @returns {moment.Moment}
 */
export function getLatestMonthlyReportDate () {
  const day = 24
  const hour = 6
  const currentMonth = moment().date(day).hour(hour).startOf('hour')

  return moment().isSameOrAfter(currentMonth) ? currentMonth : moment().subtract(1, 'month').date(day).hour(hour).startOf('hour')
}

/**
 * @param {String} name
 * @return {Boolean}
 */
export function isModuleEnabled (name) {
  const enabled = process.env['VUE_APP_' + name.toUpperCase() + '_ENABLED'] || true

  return enabled !== 'false'
}
